import { env } from '../config/env';

export class ApiErrorClass extends Error {
  code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
  }
}

export interface ApiResponse<T> {
  data: T;
  ok: true;
}

export interface ApiError {
  error: {
    code: string;
    message: string;
  };
  ok: false;
}

/**
 * Базовый fetch-клиент для API запросов
 * Добавляет заголовок X-Telegram-Init-Data для аутентификации
 */
export async function apiFetch<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const initData = getInitData();

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...(initData && { 'X-Telegram-Init-Data': initData }),
    ...options?.headers,
  };

  const url = `${env.VITE_API_URL}${path}`;

  const response = await fetch(url, {
    ...options,
    headers,
  });

  const body = await response.json() as ApiResponse<T> | ApiError;

  if (!body.ok) {
    const error = body as ApiError;
    throw new ApiErrorClass(error.error?.code ?? 'UNKNOWN_ERROR', error.error?.message ?? 'Unknown error');
  }

  return body.data;
}

/**
 * Получает initData из Telegram WebApp
 */
function getInitData(): string | null {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp?.initData) {
    return window.Telegram.WebApp.initData;
  }
  return null;
}

/**
 * Хук для получения initData
 */
export function useInitData(): string | null {
  return getInitData();
}
